<template>
    <AddMouvementFiche />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import AddMouvementFiche from "@/components/GesCom/MouvementFiche/AddMouvementFiche.vue";
  
    export default defineComponent({
      name: "AddMouvementFichePage",
      components: {
        AddMouvementFiche,
      },
    });
  </script>